/**
 * @fileoverview Botão para remover ano
 * @module components/dre/RemoveYearButton
 */

import { useState } from 'react';
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Tooltip,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

import { useDREStore } from '../../stores/dreStore';

interface RemoveYearButtonProps {
  company: 'setima' | '555';
  year: number;
}

export function RemoveYearButton({ company, year }: RemoveYearButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);
  const { removeYear } = useDREStore();

  const handleConfirm = () => {
    removeYear(company, year);
    setShowConfirm(false);
  };

  return (
    <>
      <Tooltip title="Remover ano">
        <IconButton
          size="small"
          color="error"
          onClick={() => setShowConfirm(true)}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Dialog open={showConfirm} onClose={() => setShowConfirm(false)} maxWidth="xs">
        <DialogTitle>Remover Ano</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja remover o ano <strong>{year}</strong>?
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirm(false)}>Cancelar</Button>
          <Button onClick={handleConfirm} color="error" variant="contained">
            Remover
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
